/**
 * Site-wide video download guard.
 *
 * Blocks the browser's "Save video as" / "Download video" menu on every <video>:
 *   - right-click (desktop) and long-press (mobile) on a video are cancelled;
 *   - each video gets controlslist="nodownload" (hides Chrome's download control) and
 *     disablepictureinpicture, including videos added after load (sliders, lazy videos).
 * This deters casual saving only; the file URL is still visible to developer tools.
 */
const guard = (video) => {
  video.setAttribute('controlslist', 'nodownload noplaybackrate noremoteplayback');
  video.setAttribute('disablepictureinpicture', '');
  video.setAttribute('disableremoteplayback', '');
  video.style.webkitTouchCallout = 'none';
  video.style.userSelect = 'none';
};

const guardAll = (root) => {
  if (root.nodeType !== 1) return;
  if (root.tagName === 'VIDEO') guard(root);
  root.querySelectorAll?.('video').forEach(guard);
};

guardAll(document.documentElement);

new MutationObserver((records) => {
  for (const record of records) record.addedNodes.forEach(guardAll);
}).observe(document.documentElement, { childList: true, subtree: true });

const isVideoTarget = (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return false;
  if (target.closest('video')) return true;
  // Pointer-events-none videos sit under a card: check what is under the pointer too.
  if (typeof event.clientX !== 'number') return false;
  return document.elementsFromPoint(event.clientX, event.clientY).some((el) => el.tagName === 'VIDEO');
};

document.addEventListener('contextmenu', (event) => {
  if (isVideoTarget(event)) event.preventDefault();
}, { capture: true });

document.addEventListener('dragstart', (event) => {
  if (isVideoTarget(event)) event.preventDefault();
}, { capture: true });
